import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Grid,
  Switch,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeRsvp, getCurrentUser } from "../../Store/actions/apiActions";
import { Box, useMediaQuery } from "@mui/system";
import { isAfterRSVPDate, isIOrWe } from "../../Utils/InviteeUtil";
import { useTheme } from "@emotion/react";
import CustomDivider from "../../Components/Common/CustomDivider";
import { useAuth } from "react-oidc-context";

const Bachelorette = () => {
  const { currentInvitee } = useSelector((state) => state.apiReducer);
  const dispatch = useDispatch();

  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.only("xs"));

  const handleChangeBacheloretteResponse = (event) => {
    dispatch(changeRsvp({
      ...currentInvitee.rsvp,
      bachelorette: !currentInvitee.rsvp.bachelorette,
    }));
  };

  const auth = useAuth();

  useEffect(() => {
    if (auth.isAuthenticated 
        && auth?.user?.id_token
        // && auth?.user?.profile["custom:userId"]
    ) {
      dispatch(getCurrentUser(auth.user));
    }
  }, [dispatch, auth]);

  const MyCustomDivider = () => {
    return <CustomDivider style={{ margin: `15px 40%`, width: `20%` }} />
  }

  return (
    <Grid container overflow="hidden">
      <Grid item xs={0} md={3} />
      <Grid item xs={12} md={6}>
        <Box>
          <br />
          <Typography variant="h3" sx={{ mt: 1 }}>
            Dearest {currentInvitee?.name}
          </Typography>
          <MyCustomDivider />
          <Typography variant="h4">
            Thank you for your interest in the bachelorette party! 💕
          </Typography>
          <Typography variant="h4">
            We're in the midst of finalizing all the delightful details and will share more information with you soon.
          </Typography>
          <Typography variant="h4">
            Save the date: 15 March 2025 🗓️
          </Typography>
          <Typography variant="h4">
            Time and place to be confirmed.
          </Typography>
          <MyCustomDivider />
          <Typography variant="h4">
            All the best,
          </Typography>
          <Typography variant="h4">
            Your Maid and Matron of Honor,
          </Typography>
          <Typography variant="h3">
            Ang & Lizzie
          </Typography>
          {/*           
          <Accordion
              expanded={true}
              sx={{
                backgroundColor: "rgba(0, 0, 0, 0.05)",
              }}
            >
              <AccordionSummary sx={{ pointerEvents: "none" }}>
                <p>Will you be joining us for the bachelorette party?</p>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container>
                  <Grid item xs={10} md={11}>
                    <p>
                      {currentInvitee?.rsvp?.bachelorette
                        ? !xs
                          ? `Yes, ${isIOrWe(currentInvitee)} will be attending the bachelorette party.`
                          : "Yes, Attending the bachelorette"
                        : !xs
                          ? `No, ${isIOrWe(currentInvitee)} will not be attending the bachelorette party.`
                          : "No, Not attending the bachelorette"}
                    </p>
                  </Grid>
                  <Grid item xs={2} md={1}>
                    <Switch
                      checked={currentInvitee?.rsvp?.bachelorette}
                      color="warning"
                      onChange={handleChangeBacheloretteResponse}
                      disabled={isAfterRSVPDate()}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion> */}
        </Box>
      </Grid>
      <Grid item xs={0} md={3} />
    </Grid>
  );
};

export default Bachelorette;
